<script setup lang="ts">
interface Props {
  title: string
  count?: number
}

defineProps<Props>()
</script>

<template>
  <div v-if="$slots.actions || $slots.badges || count" class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      <h3 class="te-section-label !mb-0">{{ title }}</h3>
      <span v-if="count" class="te-count-badge">{{ count }}</span>
      <slot name="badges" />
    </div>
    <slot name="actions" />
  </div>
  <h3 v-else class="te-section-label">{{ title }}</h3>
</template>

<style scoped>
.te-section-label {
  font-size: 0.8125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--p-surface-400);
  margin-bottom: 0.75rem;
}

.te-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.3125rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 700;
  background: var(--p-surface-200);
  color: var(--p-surface-600);
}
:root[class*='app-dark'] .te-count-badge {
  background: var(--p-surface-700);
  color: var(--p-surface-300);
}
</style>
